const HOME_BREADCRUMB = { title: "首页", to: "/mall/show/index" };

const buildBreadcrumbs = (matchedRoutes) => {
  const items = Array.isArray(matchedRoutes)
    ? matchedRoutes
      .map((route) => route.meta && route.meta.breadcrumb)
      .filter(Boolean)
    : [];

  if (items.length === 0 || items[items.length - 1].hidden) {
    return [];
  }

  return [HOME_BREADCRUMB]
    .concat(items.filter((item) => !item.hidden))
    .map((item, index, list) => ({
      title: item.title,
      to: index === list.length - 1 ? null : item.to,
    }));
};

module.exports = { buildBreadcrumbs };



// WEBPACK FOOTER //
// ./src/util/breadcrumb.js